var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultipleUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7083 21.875V19.7917C17.7083 18.6866 17.2694 17.6268 16.488 16.8454C15.7065 16.064 14.6467 15.625 13.5417 15.625H5.20834C4.10327 15.625 3.04346 16.064 2.26206 16.8454C1.48066 17.6268 1.04167 18.6866 1.04167 19.7917V21.875",
    stroke: "#1479FF",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37501 11.4583C11.6762 11.4583 13.5417 9.59285 13.5417 7.29167C13.5417 4.99048 11.6762 3.125 9.37501 3.125C7.07382 3.125 5.20834 4.99048 5.20834 7.29167C5.20834 9.59285 7.07382 11.4583 9.37501 11.4583Z",
    stroke: "#1479FF",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9583 21.875V19.7916C23.9577 18.8684 23.6504 17.9716 23.0848 17.242C22.5192 16.5123 21.7272 15.9912 20.8333 15.7604",
    stroke: "#1479FF",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 3.26038C17.5629 3.48986 18.3573 4.01111 18.9246 4.74195C19.4919 5.47279 19.7998 6.37166 19.7998 7.29683C19.7998 8.22201 19.4919 9.12088 18.9246 9.85172C18.3573 10.5826 17.5629 11.1038 16.6667 11.3333",
    stroke: "#1479FF",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleUser);
export default __webpack_public_path__ + "static/media/multiple-user.47f54cda3188a952e1fe68b12c28a133.svg";
export { ForwardRef as ReactComponent };